/**
 * Danish number + currency formatters. Thousands separator: period.
 * Decimal separator: comma. Currency suffix: "kr".
 *
 *   formatDkk('12500')       → "12.500 kr"
 *   formatDkk('12500.5')     → "12.500,50 kr"
 *   formatDkk('0')           → "0 kr"
 *   formatDkk(null)          → "—"
 *   formatNumber(1234567)    → "1.234.567"
 *   formatHours('4.5')       → "4,5 t"
 */

const DKK = new Intl.NumberFormat('da-DK', {
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
});

const INT = new Intl.NumberFormat('da-DK', {
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});

export function formatDkk(amount: string | number | null | undefined): string {
  if (amount === null || amount === undefined || amount === '') return '—';
  const n = typeof amount === 'string' ? Number(amount) : amount;
  if (!Number.isFinite(n)) return '—';
  // If integer, show no decimals; otherwise show 2 (Danish convention).
  const formatted = Number.isInteger(n) ? INT.format(n) : DKK.format(n).replace(/(,\d)$/, '$10'); // pad single decimal to two
  return `${formatted} kr`;
}

export function formatNumber(value: string | number | null | undefined): string {
  if (value === null || value === undefined || value === '') return '—';
  const n = typeof value === 'string' ? Number(value) : value;
  if (!Number.isFinite(n)) return '—';
  return INT.format(n);
}

export function formatHours(value: string | number | null | undefined): string {
  if (value === null || value === undefined || value === '') return '—';
  const n = typeof value === 'string' ? Number(value) : value;
  if (!Number.isFinite(n)) return '—';
  // Danish decimal: comma.
  const rounded = Math.round(n * 10) / 10;
  const s = Number.isInteger(rounded) ? String(rounded) : rounded.toFixed(1).replace('.', ',');
  return `${s} t`;
}

/** "YYYY-MM-DD" or Date → "15. apr. 2026" (Danish short form, no weekday). */
export function formatDate(value: Date | string | null | undefined): string {
  if (!value) return '—';
  const d = typeof value === 'string' ? new Date(value) : value;
  if (!(d instanceof Date) || Number.isNaN(d.getTime())) return '—';
  return new Intl.DateTimeFormat('da-DK', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  }).format(d);
}
